import React from 'react';
import ProgressStep from '@components/ProgressStep/ProgressStep';
import { Forum, Result, Task } from '@carbon/icons-react';

interface Props {
  activeStep?: number;
}

interface Step {
  icon: React.ReactNode;
  label: string;
}

const stepData: Step[] = [
  {
    icon: <Result size={16} />,
    label: '견적확인'
  },
  {
    icon: <Forum size={16} />,
    label: '견적상담'
  },
  {
    icon: <Task size={16} />,
    label: '발주/결제'
  }
];

const QuotationStepper = ({ activeStep }: Props) => {
  return <ProgressStep steps={stepData} activeStep={activeStep} />;
};

export default QuotationStepper;
